import { createContext, useContext, useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

const RefDataContext = createContext(null);

export function RefDataProvider({ children }) {
  const [data, setData] = useState({
    locations: [], trainers: [], clients: [], dogs: [], programs: [], classes: [],
  });

  const reload = useCallback(async () => {
    try {
      const [locations, trainers, clients, dogs, programs, classes] = await Promise.all([
        api.get("/locations"), api.get("/trainers"), api.get("/clients"),
        api.get("/dogs"), api.get("/programs"), api.get("/classes"),
      ]);
      setData({
        locations: locations.data, trainers: trainers.data, clients: clients.data,
        dogs: dogs.data, programs: programs.data, classes: classes.data,
      });
    } catch (e) { console.error("Failed to load reference data:", e); }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return (
    <RefDataContext.Provider value={{ ...data, reload }}>
      {children}
    </RefDataContext.Provider>
  );
}

export const useRefData = () => useContext(RefDataContext);
